import styled from 'styled-components';

import { colors, transition } from 'theme';

const borderSize = 4;

export const LocationInputAutosuggestWrapper = styled.div`
  position: relative;

  .react-autosuggest {
    &__suggestions-container {
      display: none;
      padding: 0 ${borderSize}px;

      &--open {
        display: block;
        margin-top: 4px;
        position: absolute;
        width: 100%;
        overflow-y: scroll;
        max-height: 400px;
        border: 1px solid;
        border-color: ${colors.elementGrey};
        background-color: #fff;
        font-size: 18px;
        line-height: 19px;
        border-radius: 8px;
        z-index: 2;
      }
    }

    &__suggestions-list {
      margin: 0;
      padding: 0;
      list-style-type: none;
    }

    &__suggestion {
      cursor: pointer;
      padding: 6px 4px;
      transition: all ${transition};
      box-shadow:
        0 -${borderSize}px rgba(255, 255, 255, 0) inset,
        0 ${borderSize}px rgba(255, 255, 255, 0) inset;

      &:not(:first-child) {
        border-top: 1px dashed ${colors.selectionGrey};
      }

      &--highlighted {
        background-color: ${colors.calloutGrey};
        box-shadow:
          0 -${borderSize}px white inset,
          0 ${borderSize}px white inset;
      }
    }
  }
`;
